import type { Component, Slot, VNode } from 'vue';

export type NodeOfTypeCheckFunction = (node: VNode) => boolean;

export const isNodeOfType = (expectedType: Component): NodeOfTypeCheckFunction => {
    return (node: VNode) => node.type === expectedType;
};

export const slotHasChildrenOfType = (componentSlot: Slot, expectedType: Component): boolean => {
    if (!componentSlot || typeof componentSlot !== 'function') {
        return false;
    }

    const slotsChildren = componentSlot();
    return slotsChildren.some(isNodeOfType(expectedType));
};
